export default __webpack_public_path__ + "static/media/115.1a4d741e.jpg";